/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bubble'
export default icon
